import { render, staticRenderFns } from "./createcollection.vue?vue&type=template&id=bea6f112&"
import script from "./createcollection.vue?vue&type=script&lang=js&"
export * from "./createcollection.vue?vue&type=script&lang=js&"
import style0 from "./createcollection.vue?vue&type=style&index=0&id=bea6f112&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports